"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

const CalendarMoneyBagsColourIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: 37,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ...otherProps,
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "a",
      d: "M0 0h16.157v27.551H0z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "c",
      d: "M0 0h4.326v8.44H0z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "e",
      d: "M0 0h4.326v8.44H0z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      id: "g",
      d: "M0 0h34.195v1.563H0z"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M33.636 23.882c.39 0 .706.313.706.7 0 .385-.316.699-.706.699a.703.703 0 0 1-.706-.7c0-.386.316-.7.706-.7ZM32.848 21.554V5.167a.3.3 0 0 0-.297-.294h-5.363a.786.786 0 0 1-.79-.781c0-.431.354-.782.79-.782h5.363c1.033 0 1.874.833 1.874 1.857v16.387a.785.785 0 0 1-.789.781.785.785 0 0 1-.788-.78Z",
      fill: "#4CAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0 3.31)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "b",
        fill: "#fff",
        className: "svg-fill-secondary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#a"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M1.817 27.551C.815 27.551 0 26.718 0 25.694V1.857C0 .833.815 0 1.817 0h5.698c.435 0 .789.35.789.781a.786.786 0 0 1-.79.782H1.818c-.125 0-.24.14-.24.294v23.837c0 .167.13.295.24.295H12.72c.436 0 .789.35.789.781a.785.785 0 0 1-.789.781H1.817Z",
        fill: "#4CAA50",
        mask: "url(#b)",
        className: "svg-fill-primary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(7.088)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "d",
        fill: "#fff",
        className: "svg-fill-secondary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#c"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M2.163 1.563a.583.583 0 0 0-.585.58v4.155c0 .314.268.58.585.58.323 0 .586-.26.586-.58V2.142c0-.32-.263-.58-.586-.58m0 6.879A2.156 2.156 0 0 1 0 6.298V2.142C0 .962.97 0 2.163 0 3.355 0 4.326.96 4.326 2.142v4.156c0 1.181-.971 2.143-2.163 2.143",
        fill: "#4CAA50",
        mask: "url(#d)",
        className: "svg-fill-primary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(23.535)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "f",
        fill: "#fff",
        className: "svg-fill-secondary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#e"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M2.164 1.563a.584.584 0 0 0-.586.58v4.155c0 .32.262.58.586.58a.59.59 0 0 0 .585-.58V2.142c0-.32-.263-.58-.585-.58m0 6.879C.97 8.44 0 7.479 0 6.298V2.142C0 .962.971 0 2.164 0 3.356 0 4.326.96 4.326 2.142v4.156c0 1.181-.97 2.143-2.162 2.143",
        fill: "#4CAA50",
        mask: "url(#f)",
        className: "svg-fill-primary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M24.077 4.886h-13.38a.786.786 0 0 1-.789-.78c0-.432.354-.783.79-.783h13.38c.434 0 .787.351.787.782a.785.785 0 0 1-.788.781",
      fill: "#4CAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(0 10.006)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
        id: "h",
        fill: "#fff",
        className: "svg-fill-secondary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#g"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M33.407 1.563H.79a.786.786 0 0 1-.79-.781C0 .35.355 0 .79 0h32.618c.435 0 .788.35.788.782a.785.785 0 0 1-.788.78",
        fill: "#4CAA50",
        mask: "url(#h)",
        className: "svg-fill-primary"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M9.395 16.388H5.273a.785.785 0 0 1-.789-.782c0-.43.353-.781.789-.781h4.122c.435 0 .788.35.788.781a.785.785 0 0 1-.788.782M16.338 16.388h-4.122a.785.785 0 0 1-.788-.782c0-.43.353-.781.788-.781h4.122c.436 0 .789.35.789.781a.785.785 0 0 1-.789.782M9.395 19.182H5.273a.785.785 0 0 1-.789-.781c0-.432.353-.782.789-.782h4.122c.435 0 .788.35.788.782a.785.785 0 0 1-.788.78M16.338 19.182h-4.122a.785.785 0 0 1-.788-.781c0-.432.353-.782.788-.782h4.122c.436 0 .789.35.789.782a.785.785 0 0 1-.789.78M9.395 21.977H5.273a.785.785 0 0 1-.789-.781c0-.432.353-.782.789-.782h4.122c.435 0 .788.35.788.782a.785.785 0 0 1-.788.78M16.338 21.977h-4.122a.785.785 0 0 1-.788-.781c0-.432.353-.782.788-.782h4.122c.436 0 .789.35.789.782a.785.785 0 0 1-.789.78M9.395 24.77H5.273a.785.785 0 0 1-.789-.78c0-.432.353-.782.789-.782h4.122c.435 0 .788.35.788.782a.785.785 0 0 1-.788.78M16.338 24.77h-4.122a.785.785 0 0 1-.788-.78c0-.432.353-.782.788-.782h4.122c.436 0 .789.35.789.782a.785.785 0 0 1-.789.78M23.282 16.388h-4.123a.785.785 0 0 1-.788-.782c0-.43.353-.781.788-.781h4.123c.435 0 .788.35.788.781a.785.785 0 0 1-.788.782M30.225 16.388h-4.123a.785.785 0 0 1-.788-.782c0-.43.353-.781.788-.781h4.123c.435 0 .788.35.788.781a.785.785 0 0 1-.788.782",
      fill: "#4CAA50",
      className: "svg-fill-primary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "#FFF",
      fillRule: "nonzero",
      className: "svg-fill-secondary",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M27.247 24.778H22.6c-1.743 0-3.923 1.588-5.941 4l-.166.202c-3.545 4.414-4.655 11.552-.495 14.113l.146.085.025.019c.25.166.671.314 1.342.443.238.046.501.089.791.127l.455.053.494.048.536.04.577.033.62.027.665.018.708.011.754.003 8.147-.01c1.125-.114 1.952-.32 2.65-.672 4.825-2.416 3.492-9.665-.485-14.335-2.152-2.53-4.43-4.205-6.175-4.205ZM22.6 26.365h4.648c1.124 0 3.097 1.451 4.964 3.646 3.409 4.003 4.532 10.112.984 11.889-.506.254-1.155.416-2.023.508l-8.064.005c-.25 0-.491 0-.726-.003l-.68-.01-.635-.018-.591-.024-.28-.015-.526-.034a24.79 24.79 0 0 1-.484-.04l-.443-.047-.207-.025-.382-.055-.176-.03-.167-.03a7.253 7.253 0 0 1-.268-.057l-.218-.056a2.696 2.696 0 0 1-.17-.053l-.068-.026c-.014-.006-.02-.008-.018-.004l.055.05-.155-.112c-3.293-1.843-2.279-8.217.908-12.028 1.737-2.077 3.597-3.431 4.722-3.431Z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "m28.928 17.75-7.061 1.838a.793.793 0 0 0-.552 1.023l1.776 5.216c.11.323.416.54.758.538l3.445-.022a.794.794 0 0 0 .764-.593l1.84-7.032a.794.794 0 0 0-.97-.969Zm-.91 1.875-1.344 5.134-2.264.015-1.316-3.867 4.923-1.282ZM29.076 37.476l-.224-.422a.416.416 0 0 0-.264-.21.402.402 0 0 0-.328.06c-.47.321-.912.487-1.314.49-.13 0-.378-.028-.855-.16-.99-.274-1.43-.201-1.89-.122a6.196 6.196 0 0 0 .306-1.636l2.243-.012c.11 0 .215-.047.292-.128a.436.436 0 0 0 .12-.304l-.003-.486a.437.437 0 0 0-.123-.303.408.408 0 0 0-.294-.124l-2.31.015a6.263 6.263 0 0 0-.176-.705c-.153-.51-.184-.77-.186-.897a1.001 1.001 0 0 1 .419-.86c.32-.244.77-.37 1.334-.373.43-.003.8.113 1.129.345.33.245.553.56.684.962.04.117.125.211.235.26.11.046.235.042.341-.013l.407-.208a.432.432 0 0 0 .218-.495 2.693 2.693 0 0 0-1.13-1.583 3.22 3.22 0 0 0-1.915-.586c-.939.006-1.693.233-2.241.68-.57.472-.858 1.13-.851 1.955-.001.035.003.07.011.103l.35 1.423-.581.004a.407.407 0 0 0-.293.127.436.436 0 0 0-.12.304l.004.486c0 .114.045.223.123.303.078.08.184.124.294.123l.694-.004c-.05.833-.268 1.544-.65 2.117a.438.438 0 0 0 .049.55l.509.52c.136.143.35.166.513.058.364-.239.844-.363 1.42-.367.128 0 .382.027.87.16.468.129.823.19 1.085.188.764-.005 1.436-.238 1.993-.691.16-.13.204-.36.105-.544"
      })]
    })]
  })]
});

CalendarMoneyBagsColourIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(CalendarMoneyBagsColourIcon);

exports.default = _default;